"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIeVersion = getIeVersion;
/**
 * 只需要判断是不是 ie 11 以下 所以不处理其他的浏览器
 * 获取ie的版本信息 如果返回 -1 则不是ie浏览器
 */
function getIeVersion() {
  var _navigator = navigator,
    userAgent = _navigator.userAgent; // 取得浏览器的userAgent字符串

  if (userAgent.match(/rv:([\d.]+)\) like Gecko/)) {
    return 11;
  }
  var match = userAgent.match(/MSIE ([\d.]+)/);
  if (match && match[1]) {
    return +match[1];
  }
  return -1;
}